import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../../components/layout/ToastStyles";
import {Apis} from "../../../util/data";
import PageContainer from "../../../components/layout/PageContainer";
import PageSection from "../../../components/layout/PageSection";
import {PageBackLabel} from "../../../components/layout/PageBackLabel";
import PageTitle from "../../../components/layout/PageTitle";
import PdfRiskForm from "./PdfRiskForm";

const PdfRiskNew = () => {

  const navigate = useNavigate()

  const {id} = useParams()

  const onCreate = (data) => {
    axios.post(Apis.PROD + '/pdf/riesgo/' + id + '/pdf/' + data.codigo)
      .then(res => {
        successToast("Pdf del Riesgo creado correctamente")
        navigate('/riesgos/' + id + '/pdfs')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Pdfs del Riesgo' onClick={() => navigate('/riesgos/' + id + '/pdfs')}/>
        <PageTitle title={'Pdf del Riesgo'}/>
      </PageSection>

      <PageSection>
          <PdfRiskForm value={{}} onSubmit={(pdf) => onCreate(pdf)}/>
      </PageSection>
    </PageContainer>
  )
}

export default PdfRiskNew;
